// ** React Imports
import { useEffect } from 'react'

// ** Next Import
import { useRouter } from 'next/router'

// ** Hooks Import
import { useAuth } from 'src/hooks/useAuth'
import { authStorage } from 'src/utils/authStorage'
import authConfig from 'src/configs/auth'

const GuestGuard = props => {
  const { children, fallback } = props

  const auth = useAuth()

  const router = useRouter()

  //  const storedToken = getStoredToken()
  //  const storedUserData = getStoredUserData()
  const storedToken = authStorage.getStoredToken(authConfig.storageTokenKeyName)
  const storedUserData = authStorage.getStoredUser('userData')


  useEffect(() => {
    if (!router.isReady) {
      return
    }
    if (storedUserData && storedToken) {
      router.replace('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.route])
  if (auth.loading || (storedToken !== null && storedUserData !== null)) {
    return fallback
  }

  return <>{children}</>
}

export default GuestGuard
